import {
  Box,
  ExpandableSection,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import ReactJson from "react-json-view";
import { useContext } from "react";
import { DigitalPaymentDocument } from "../../../types/documents";
import { StageContext } from "../../../contexes/OrderIdContext";
import { AsyncActionButton } from "../../common/AsyncActionButton";
import { usePaymentRedrive } from "../../../hooks/usePaymentRedrive";

interface DigitalPaymentDocumentViewProps {
  dpd: DigitalPaymentDocument;
  jsonViewProps: any;
}

export function DigitalPaymentDocumentView({
  dpd,
  jsonViewProps,
}: DigitalPaymentDocumentViewProps) {
  const stage = useContext(StageContext);
  const { status, error, redrive } = usePaymentRedrive(stage);

  return (
    <SpaceBetween size="l">
      <SpaceBetween direction="horizontal" size="xs">
        <AsyncActionButton
          label="Redrive Royalty Payment"
          successLabel="Redrive Submitted"
          failedLabel="Redrive Failed"
          status={status}
          onClick={() => redrive(dpd.id)}
          errorMessage={error}
        />
      </SpaceBetween>
      <ExpandableSection
        header={
          <Box variant="h4" margin={{ top: "xxs" }}>
            {dpd.id} (Digital Payment Document)
          </Box>
        }
        variant="container"
      >
        <ReactJson src={dpd.body} {...jsonViewProps} />
      </ExpandableSection>
    </SpaceBetween>
  );
}
